import { i18nKey } from '@/i18n';
import type { Menu } from './types';

export default [
  {
    code: 'MOBILE_TODO',
    label: i18nKey.t('menu:todo'),
    path: '/todo',
    icon: 'todo',
    public: true,
  },
  {
    code: 'MOBILE_HOME',
    label: i18nKey.t('menu:workspace'),
    path: '/',
    icon: 'workspace',
    public: true,
  },
  {
    code: 'MOBILE_GLOBAL_SEARCH',
    label: i18nKey.t('menu:globalSearch'),
    path: '/global-search',
    icon: 'search',
    public: true,
  },
  {
    code: 'MOBILE_ME',
    label: i18nKey.t('menu:me'),
    path: '/me',
    icon: 'me',
    public: true,
  },
] satisfies Menu[];
